export default {
  infoTitle: '院校资源数据信息',
  infoDesc: '可查询申请指引和申请费信息,同时查看学校相关的语言类型',
  infoTypeApplicationFee: '申请费详细',
  infoTypeLanguageReq: '语言类型',
  schoolName:'院校名称',
  majorLevel: '课程级别',
  keywordSearch: '关键字搜索',
  searchResultEmpty: '请更改搜寻',
  search: '搜索',
  reset: '重置',
  dataTotalNumber: '共{totalNumber}条数据',
  country: '国家',
  institutionName: '学校',
  serialNumber: '序号',
  applicationFeeFound: '免申请费?',
  applicationFee: '申请费',
  applicationFeeDetail: '部分专业内容',
  applicationLang: '语言类型',
  applicationLangGoDetail: '查看语言类型',
  operation: '操作',
  viewDetail: '查看详细',
  yes: '是',
  no: '否',
  previous: '上一条',
  next: '下一条',
  viewApplicationFee: '查看申请费',
  viewLanguageReq: '查看语言类型',
  professionalDetail: '专业内容',
  matchCourseDetail: '符合条件课程',
  courseDetailDataTotalNumber: '共{totalNumber}条资料',
  langTypeDesc: '介绍',
  langTypeOptionPlaceholder: '是否有语言类型'
}
